export type GradeLevel = 9 | 10 | 11 | 12;
export type Curriculum = 'CBSE' | 'ICSE' | 'ISC' | 'STATE' | 'IB' | 'OTHER';
export type ExamTrack = 'SCHOOL' | 'BOARDS' | 'JEE' | 'NEET' | 'CUET' | 'OLYMPIAD' | 'OTHER';

export interface SubjectOption {
  key: string;
  label: string;
  grades: GradeLevel[];
  tracks?: ExamTrack[];
}

export const SUBJECT_CATALOG: SubjectOption[] = [
  { key: 'mathematics', label: 'Mathematics', grades: [9, 10, 11, 12] },
  { key: 'applied-mathematics', label: 'Applied Mathematics', grades: [11, 12] },
  { key: 'science', label: 'Science', grades: [9, 10] },
  { key: 'physics', label: 'Physics', grades: [11, 12] },
  { key: 'chemistry', label: 'Chemistry', grades: [11, 12] },
  { key: 'biology', label: 'Biology', grades: [11, 12] },
  { key: 'english', label: 'English', grades: [9, 10, 11, 12] },
  { key: 'hindi', label: 'Hindi', grades: [9, 10, 11, 12] },
  { key: 'sanskrit', label: 'Sanskrit', grades: [9, 10, 11, 12] },
  { key: 'urdu', label: 'Urdu', grades: [9, 10, 11, 12] },
  { key: 'french', label: 'French', grades: [9, 10, 11, 12] },
  { key: 'german', label: 'German', grades: [9, 10, 11, 12] },
  { key: 'regional-language', label: 'Regional language', grades: [9, 10, 11, 12] },
  { key: 'second-language', label: 'Second language', grades: [9, 10, 11, 12] },
  { key: 'social-science', label: 'Social Science', grades: [9, 10] },
  { key: 'history', label: 'History', grades: [11, 12] },
  { key: 'geography', label: 'Geography', grades: [11, 12] },
  { key: 'political-science', label: 'Political Science', grades: [11, 12] },
  { key: 'economics', label: 'Economics', grades: [9, 10, 11, 12] },
  { key: 'accountancy', label: 'Accountancy', grades: [11, 12] },
  { key: 'business-studies', label: 'Business Studies', grades: [11, 12] },
  { key: 'commercial-studies', label: 'Commercial Studies', grades: [9, 10] },
  { key: 'commercial-applications', label: 'Commercial Applications', grades: [9, 10] },
  { key: 'entrepreneurship', label: 'Entrepreneurship', grades: [11, 12] },
  { key: 'statistics', label: 'Statistics', grades: [11, 12] },
  { key: 'computer-science', label: 'Computer Science', grades: [9, 10, 11, 12] },
  { key: 'computer-applications', label: 'Computer Applications', grades: [9, 10] },
  { key: 'informatics-practices', label: 'Informatics Practices', grades: [11, 12] },
  { key: 'information-technology', label: 'Information Technology', grades: [9, 10, 11, 12] },
  { key: 'artificial-intelligence', label: 'Artificial Intelligence', grades: [9, 10, 11, 12] },
  { key: 'data-science', label: 'Data Science', grades: [9, 10, 11, 12] },
  { key: 'robotics', label: 'Robotics', grades: [9, 10, 11, 12] },
  { key: 'web-applications', label: 'Web Applications', grades: [11, 12] },
  { key: 'psychology', label: 'Psychology', grades: [11, 12] },
  { key: 'sociology', label: 'Sociology', grades: [11, 12] },
  { key: 'philosophy', label: 'Philosophy', grades: [11, 12] },
  { key: 'anthropology', label: 'Anthropology', grades: [11, 12] },
  { key: 'legal-studies', label: 'Legal Studies', grades: [11, 12] },
  { key: 'home-science', label: 'Home Science', grades: [9, 10, 11, 12] },
  { key: 'biotechnology', label: 'Biotechnology', grades: [11, 12] },
  { key: 'agriculture', label: 'Agriculture', grades: [9, 10, 11, 12] },
  { key: 'engineering-graphics', label: 'Engineering Graphics', grades: [11, 12] },
  { key: 'mass-media', label: 'Mass Media Studies', grades: [11, 12] },
  { key: 'fashion-studies', label: 'Fashion Studies', grades: [9, 10, 11, 12] },
  { key: 'tourism', label: 'Tourism', grades: [9, 10, 11, 12] },
  { key: 'physical-education', label: 'Physical Education', grades: [9, 10, 11, 12] },
  { key: 'yoga', label: 'Yoga', grades: [9, 10, 11, 12] },
  { key: 'ncc', label: 'NCC', grades: [9, 10, 11, 12] },
  { key: 'environmental-science', label: 'Environmental Science', grades: [9, 10, 11, 12] },
  { key: 'art', label: 'Art', grades: [9, 10, 11, 12] },
  { key: 'fine-arts', label: 'Fine Arts', grades: [11, 12] },
  { key: 'music', label: 'Music', grades: [9, 10, 11, 12] },
  { key: 'dance', label: 'Dance', grades: [9, 10, 11, 12] },
];

export function subjectsFor(grade: GradeLevel, track: ExamTrack): SubjectOption[] {
  const available = SUBJECT_CATALOG.filter((subject) => subject.grades.includes(grade));
  const priority: Record<ExamTrack, string[]> = {
    JEE: ['physics', 'chemistry', 'mathematics'],
    NEET: ['physics', 'chemistry', 'biology'],
    CUET: ['english', 'mathematics', 'economics', 'accountancy', 'business-studies'],
    BOARDS: [],
    SCHOOL: [],
    OLYMPIAD: ['mathematics', 'science', 'physics', 'chemistry', 'biology'],
    OTHER: [],
  };
  const rank = priority[track];
  return [...available].sort((left, right) => {
    const leftIndex = rank.indexOf(left.key);
    const rightIndex = rank.indexOf(right.key);
    if (leftIndex === -1 && rightIndex === -1) return left.label.localeCompare(right.label);
    if (leftIndex === -1) return 1;
    if (rightIndex === -1) return -1;
    return leftIndex - rightIndex;
  });
}
